<video *ngIf="isVideo && url" [id]="videoId" class="video" controls (play)="onPlay()">
  <source [src]="url">
</video>
<div *ngIf="isYoutube" class="youtube" #youtubeContainer></div>
<div *ngIf="isMeetingPulse" class="meetingpulse">
  <iframe [src]="url | safeUrl" style="border:none;" allow=“encrypted-media” credentialless>
  </iframe>
</div>
<div *ngIf="isSIM && !!simSrc" class="sim">
  <iframe [srcdoc]="simSrc" credentialless></iframe>
</div>
<div *ngIf="isHyperbound && url" class="hyperbound">
  <iframe [src]="url | safeUrl" allow="microphone *" credentialless></iframe>
</div>
<div *ngIf="isImage" class="image">
  <img [src]="url"/>
</div>
<div *ngIf="isVimeo" class="vimeo">
  <iframe [src]="url | safeUrl" frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
          style="position:absolute;top:0;left:0;width:100%;height:100%;"
          credentialless
  ></iframe>
</div>
<script src="https://player.vimeo.com/api/player.js"></script>
